import { Injectable } from "@angular/core";
import {
  BILLING_TYPE,
  EXPORT_CHARGE_ITEM_TYPE,
  IAggregatedChargeItemsInfo,
  IChargeItemsInfo,
  IDataSourceBackendParam,
  IFilter,
  IReference,
} from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { ApiService } from "src/app/providers/api/api.service";
import { BaseApiService } from "src/app/providers/api/baseApi.service";

@Injectable({
  providedIn: "root",
})
export class BillingApiService extends BaseApiService {
  constructor(private api: ApiService) {
    super(
      "Invoice", // Theme !
      ["dashboard/sendChargeItems"], // Post route paths
      ["dashboard/chargeItemsInfos", "dashboard/nbChargeItemsInfos", "dashboard/exportChargeItem"],
      ["dashboard/chargeItemsStatus", "dashboard/newChargeItemComment", "dashboard/chargeItemsCheckCriteria"], // Update route paths
      [] // Delete route paths
    );
  }

  public findInvoices(
    params: IDataSourceBackendParam,
    patientId?: string,
    aggregated?: boolean
  ): Observable<IChargeItemsInfo[] | IAggregatedChargeItemsInfo[]> {
    return this.api.get(this.readRoutes[0], {
      pageNumber: params.pageNumber,
      pageSize: params.pageSize,
      search: params.search,
      sortId: params.sortId,
      sortOrder: params.sortOrder,
      servicesIds: params.services,
      filters: JSON.stringify(params.filters),
      patientId: patientId,
      aggregated,
    }) as Observable<IChargeItemsInfo[] | IAggregatedChargeItemsInfo[]>;
  }

  public getInvoicesCount(services?: string[], filters?: IFilter[], patientId?: string): Observable<{ count: number }> {
    const params: any = {};

    if (services?.length) {
      params.servicesIds = services;
    }
    if (filters?.length) {
      params.filters = JSON.stringify(filters);
    }

    if (patientId) {
      params.patientId = patientId;
    }

    return this.api.get(this.readRoutes[1], params) as Observable<{ count: number }>;
  }

  public exportChargeItems(
    identifiers: string[],
    type: EXPORT_CHARGE_ITEM_TYPE,
    serviceIds: string[],
    columnOrders: string[],
    isAggregatedView: boolean
  ): Observable<Blob> {
    return this.api.getBlob(this.readRoutes[2], {
      identifiers: JSON.stringify(identifiers),
      type,
      serviceIds: JSON.stringify(serviceIds),
      columnOrders: columnOrders?.length ? JSON.stringify(columnOrders) : undefined,
      aggregated: isAggregatedView,
    }) as Observable<Blob>;
  }

  public sendChargeItems(identifiers: string[]): Observable<unknown> {
    return this.api.post(this.createRoutes[0], { identifiers });
  }

  public updateChargeItemStatus(identifiers: string[], newStatus: BILLING_TYPE): Observable<unknown> {
    return this.api.put(this.updateRoutes[0], { identifiers, newStatus });
  }

  public addChargeItemComment(chargeItemId: string, comment: string): Observable<{ text: string; author?: IReference; time?: string }> {
    return this.api.put(this.updateRoutes[1], { identifier: chargeItemId, comment }) as Observable<{
      text: string;
      author?: IReference;
      time?: string;
    }>;
  }

  public recalculateAdherences(identifiers: string[]): Observable<unknown> {
    return this.api.put(this.updateRoutes[2], { identifiers });
  }
}
